import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SsrStatusService } from './ssr-status.service';
import { isNoIndexPath } from './noindex-routes';

/**
 * Applies noindex to utility routes (/login, /cart, /registration/*, /knot).
 */
@Injectable({
	providedIn: 'root',
})
export class NoIndexSeoService {
	private readonly meta = inject(Meta);
	private readonly router = inject(Router);
	private readonly ssrStatus = inject(SsrStatusService);

	applyForUrl(url: string = this.router.url): boolean {
		if (!isNoIndexPath(url)) {
			return false;
		}
		this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
		this.ssrStatus.noIndex();
		return true;
	}
}
